module.exports = __webpack_public_path__ + "assets/img/world_cup_ticket.webp?ce874e2434f287ebe2b6fffb0d629fa8";